import * as angular from 'angular';

angular.module('mode.chart').controller('ChartSettingsController', [
  '$scope',
  'lodash',
  '$timeout',
  'ChartInterpolaterService',
  'ChartThemeService',
  'ViewService',
  function ($scope, _, $timeout, ChartInterpolater, ChartThemeService, ViewService) {
    $scope.advancedOpen = false;
    $scope.tempYmin = $scope.view ? $scope.view.ymin : '';
    $scope.tempYmax = $scope.view ? $scope.view.ymax : '';
    $scope.tempXmin = $scope.view ? $scope.view.xmin : '';
    $scope.tempXmax = $scope.view ? $scope.view.xmax : '';

    $scope.series = { number: [], grouped: [] };
    $scope.columns = { all: [], number: [], numberAndDate: [], grouped: [] };

    $scope.accordion = {
      chart: true,
      format: false,
    };

    $scope.rotations = [
      { name: '+45°', value: 45 },
      { name: '+90°', value: 90 },
      { name: '-45°', value: -45 },
      { name: '-90°', value: -90 },
    ];
    $scope.formats = [
      { name: 'percent', value: 'percent' },
      { name: 'currency', value: 'currency' },
      { name: 'thousands', value: 'thousands' },
      { name: 'millions', value: 'millions' },
      { name: 'billions', value: 'billions' },
      { name: 'none', value: 'none' },
    ];
    $scope.precisions = [
      { name: '0', value: 0 },
      { name: '0.1', value: 1 },
      { name: '0.01', value: 2 },
      { name: '0.001', value: 3 },
    ];
    $scope.dateFormats = [
      { name: 'YYYY-MM-DD HH:MM:SS', value: 'hour' },
      { name: 'Mon YYYY', value: 'full_mon' },
      { name: 'Day Mon YYYY', value: 'full_day' },
      { name: 'Mon Day YYYY', value: 'usa_full' },
      { name: 'MM/DD', value: 'mon_day' },
      { name: 'YYYY', value: 'year' },
      { name: 'none', value: 'none' },
    ];
    $scope.themes = ChartThemeService.getPalettes([
      'contrast',
      'toughtea',
      'rainbow',
      'candy',
      'monochrome',
      'pastel',
      'green',
      'blue',
      'orange',
      'purple',
      'gray',
      'colorblind',
    ]);
    $scope.simpleThemes = ChartThemeService.getPalettes(['green', 'blue', 'orange', 'purple', 'gray']);
    $scope.aggregates = [
      { name: 'Sum', value: 'sum' },
      { name: 'Count', value: 'count' },
      { name: 'Count Unique', value: 'countUnique' },
      { name: 'Average', value: 'average' },
      { name: 'Median', value: 'median' },
      { name: 'Std Deviation', value: 'stdDev' },
    ];
    $scope.pieAggregates = [
      { name: 'Sum', value: 'sum' },
      { name: 'Count', value: 'count' },
    ];

    function numberTypes(column) {
      if (column != null) {
        return column.type === 'number' || column.type === 'integer' || column.type === 'float';
      }
      // Perhaps column is null due to dataset schema changing after a run
    }

    function dataTypes(column) {
      return (
        column.type === 'number' ||
        column.type === 'integer' ||
        column.type === 'float' ||
        column.type === 'datetime' ||
        column.type === 'date'
      );
    }

    function numberSort(a, b) {
      const x = parseFloat(a.name),
        y = parseFloat(b.name);
      if (x > y) {
        return 1;
      } else if (x < y) {
        return -1;
      } else {
        return 0;
      }
    }

    function updateSeries(data) {
      if (angular.isDefined($scope.view) && angular.isDefined($scope.view.g) && $scope.view.g !== null) {
        const sortFunction = numberTypes(_.find(data.columns, { name: $scope.view.g })) ? numberSort : undefined;
        $scope.series.grouped = _.chain(data.content)
          .map($scope.view.g)
          .sort()
          .uniq(true)
          .map(function (seriesName) {
            const displayName = seriesName === undefined || seriesName === null ? '&lt;null&gt;' : seriesName;
            return { name: seriesName, type: 'number', displayName: displayName };
          })
          .value()
          .sort(sortFunction);
        $scope.series.grouped.unshift({ name: '$mode-select-all$', type: 'number', displayName: 'All Series' });
      }
      $scope.series.number = _.filter(data.columns, numberTypes);
    }

    function sanitizeSeries() {
      if (!$scope.view) {
        return;
      }
      if ($scope.series.grouped.length > 10) {
        $scope.view.f = [$scope.series.grouped[0].name];
      } else {
        $scope.view.f = ['$mode-select-all$'];
      }
    }

    function updateColumns(data) {
      $scope.columns.all = data.columns;
      $scope.columns.number = _.filter(data.columns, numberTypes);
      $scope.columns.numberAndDate = _.filter(data.columns, dataTypes);
      $scope.columns.grouped = _.filter(data.columns, function (column) {
        return _.chain(data.content).map(column.name).uniq().value().length < 100;
      });
    }

    function setValueFn() {
      if (!$scope.view) {
        return;
      }
      $scope.view.gValueFn = $scope.view.gValueFn
        ? $scope.view.gValueFn
        : $scope.view.aggregate
          ? $scope.view.aggregate
          : 'sum';
      $scope.view.aggregate = $scope.view.gValueFn;
    }

    function setValueColumn() {
      if (!$scope.view) {
        return;
      }
      $scope.view.gValueColumn =
        $scope.columns.number && $scope.columns.number.length ? $scope.columns.number[0].name : $scope.view.x;
    }

    function getThemeThumbStyle(themeID) {
      const thumbPalette = ChartThemeService.getThumbPalette(themeID);
      return buildThumbStyle(thumbPalette[0], thumbPalette[1]);
    }

    function buildThumbStyle(color1, color2) {
      return [
        'border-top-color:',
        color1,
        ';border-left-color:',
        color1,
        ';border-right-color:',
        color2,
        ';border-bottom-color:',
        color2,
        ';',
      ].join('');
    }

    function loadDefaultThemeThumbStyle(simpleEnabled) {
      if (simpleEnabled) {
        return getThemeThumbStyle(ChartThemeService.DEFAULT_SIMPLE_THEME_ID);
      } else {
        return getThemeThumbStyle(ChartThemeService.DEFAULT_THEME_ID);
      }
    }

    function getThemeByDuckTypingFirstColor(colorArr) {
      const filterByFirstColor = firstColorMatchInSet(colorArr);
      return ChartThemeService.getThemesAll().filter(filterByFirstColor)[0];
    }

    function firstColorMatchInSet(colors) {
      return function firstColorMatch(theme) {
        return theme.colors[0] === colors[0];
      };
    }

    function getThemeColors(isSimple) {
      if ($scope.view && angular.isArray($scope.view.chartColors)) {
        const theme = getThemeByDuckTypingFirstColor($scope.view.chartColors);
        if (theme) {
          return getThemeThumbStyle(theme.id);
        } else {
          return loadDefaultThemeThumbStyle(isSimple);
        }
      } else {
        return loadDefaultThemeThumbStyle(isSimple);
      }
    }

    $scope.$watch('data', function (data) {
      if (angular.isDefined(data)) {
        updateSeries(data);
        updateColumns(data);
      }
    });

    $scope.$watch(
      function () {
        return { token: $scope.chartToken, view: $scope.view || {} };
      },
      function (chart, oldChart) {
        if (!chart.view) {
          return;
        }

        if (chart.view.g && chart.token !== oldChart.token && oldChart.token) {
          // this is just a chart switch to a chart with a group so update grouped series
          updateSeries($scope.data);
        }
        if (chart.token !== oldChart.token) {
          $scope.tempYmin = chart.view.ymin;
          $scope.tempYmax = chart.view.ymax;
          $scope.tempXmin = chart.view.xmin;
          $scope.tempXmax = chart.view.xmax;
        }
      },
      true
    );

    $scope.updateGroupBy = function () {
      // this is an actual group by change
      setValueFn();
      setValueColumn();
      // set default select series
      updateSeries($scope.data);
      sanitizeSeries();
      $scope.updateSettings();
    };

    $scope.updateSettings = function () {
      ViewService.updateChartSettingsForType($scope.chartToken, $scope.view);
    };

    $scope.updateYColumns = function () {
      $scope.setXMin();
      $scope.setXMax();
      ChartInterpolater.setRange($scope.view, $scope.data.content, true);
      // format could break if x type changes so just blow away xformat
      delete $scope.view.xformat;
      $scope.updateSettings();
    };

    $scope.updateXColumns = function () {
      $scope.setXMin();
      $scope.setXMax();
      ChartInterpolater.setRange($scope.view, $scope.data.content, true);
      // format could break if x type changes so just blow away xformat
      delete $scope.view.xformat;

      $scope.updateSettings();
    };

    $scope.aggregateChanged = function (aggregate) {
      if (!$scope.view) {
        return;
      }
      $scope.view.gValueFn = aggregate;
      $scope.updateSettings();
    };

    $scope.switchAccordion = function (view) {
      if (view === 'chart') {
        $scope.accordion.format = false;
        $scope.accordion.chart = true;
      } else {
        $scope.accordion.chart = false;
        $scope.accordion.format = true;
      }
    };

    $scope.setYMin = function (update = false) {
      if (!angular.isDefined($scope.tempYmin) || $scope.tempYmin === '') {
        delete $scope.view.ymin;
      } else {
        $scope.view.ymin = $scope.tempYmin;
      }

      if (update) {
        $scope.updateSettings();
      }
    };

    $scope.setYMax = function (update = false) {
      if (!angular.isDefined($scope.tempYmax) || $scope.tempYmax === '') {
        delete $scope.view.ymax;
      } else {
        $scope.view.ymax = $scope.tempYmax;
      }

      if (update) {
        $scope.updateSettings();
      }
    };

    $scope.setXMin = function (update = false) {
      if (!angular.isDefined($scope.tempXmin) || $scope.tempXmin === '') {
        delete $scope.view.xmin;
      } else {
        $scope.view.xmin = $scope.tempXmin;
      }

      if (update) {
        $scope.updateSettings();
      }
    };

    $scope.setXMax = function (update = false) {
      if (!angular.isDefined($scope.tempXmax) || $scope.tempXmax === '') {
        delete $scope.view.xmax;
      } else {
        $scope.view.xmax = $scope.tempXmax;
      }

      if (update) {
        $scope.updateSettings();
      }
    };

    $scope.advancedText = function () {
      return $scope.advancedOpen ? 'less' : 'more';
    };

    $scope.isDateType = function () {
      if (!$scope.columns || !$scope.view) {
        return false;
      }
      return _.some($scope.columns.numberAndDate, function (col) {
        return col.name === $scope.view.x && (col.type === 'datetime' || col.type === 'date');
      });
    };

    $scope.isNumType = function () {
      if (!$scope.columns || !$scope.view) {
        return false;
      }
      return _.some($scope.columns.numberAndDate, function (col) {
        return col.name === $scope.view.x && numberTypes(col);
      });
    };

    $scope.toggleAdvanced = function () {
      $scope.advancedOpen = !$scope.advancedOpen;
    };

    $scope.setTheme = function (theme) {
      const defaultTheme = ChartThemeService.DEFAULT_THEME_ID;

      if (ChartThemeService.hasTheme(theme)) {
        ViewService.updateChartTheme($scope.chartToken, theme, ChartThemeService.getTheme(theme).colors);
      } else {
        ViewService.updateChartTheme($scope.chartToken, theme, ChartThemeService.getTheme(defaultTheme).colors);
      }
    };
  },
]);
